// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dIHN","name":"styles_name__2FNAC","phone":"styles_phone__1WYkG"};